<template>
  <div class=" card-style">
    <div>
      <div class="card-header-title">
        <h2>
          Dangerous Goods Portal
          <br>
          <span style="font-size: 16px; font-weight: normal;">- Login -</span>
        </h2>
      </div>
    </div>
    <div class="card-content">
      <div class="notification is-danger" v-if="$route.params.appIsIdle">
        <button class="delete"></button>
        You have been logged out due to inactivity, please login to continue.
      </div>
      <div class="notification is-success" v-if="$route.params.signUpSuccessful">
        <button class="delete"></button>
        You have signed up successfully, please login to continue.
      </div>
      <form class=" has-min-width-300 has-max-width-350" style="margin: 0 auto;" action method="POST" @submit.prevent="login">

        <b-field
          label="Username/Email"
          :type="{'is-danger': errors.has('username')}"
          :message="errors.first('username')"
        >
          <b-input
            v-model="username"
            name="username"
            placeholder="Username/Email"
            v-validate="'required'"
          ></b-input>
        </b-field>

        <b-field
          label="Password"
          :type="{'is-danger': errors.has('password')}"
          :message="errors.first('password')"
        >
          <b-input
            type="password"
            v-model="password"
            name="password"
            placeholder="Password"
            v-validate="'required'"
            password-reveal
          ></b-input>
        </b-field>

        <div class="field has-margin-top-30">
          <div class="control is-flex justify-space-between align-items-center">
            <span @click="forgotPassword">
              <a>Forgot Password?</a>
            </span>
            <button
              class="button is-primary is-pulled-right"
              :class="{'is-loading': loading, 'is-disabled': loading}"
            >
              <span>Login</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { onLogin } from "@/vue-apollo";

import authMutations from "@/modules/rootModule/api/graphql/mutations/Authentication";
import { ROOT_MUTATION_TYPES } from "@/store/mutation-types";
import getUrlFromUserRoles from "@/modules/commonModule/helpers/getRouteFromUserRole";
import ForgotPasswordCard from "./ForgotPasswordCard.vue";
/**
 * This component is the Login card used to authenticate a user.
 */
export default {
  name: "LoginCard",
  components: { ForgotPasswordCard },

  props: {
    onLogin: { type: Function, default: () => {} }
  },

  data() {
    return {
      username: null,
      password: null,
      loading: false
    };
  },

  methods: {
    /**
     * Reset the user password
     */

    forgotPassword() {
      this.$modal.open({
        parent: this,
        component: ForgotPasswordCard,
        hasModalCard: true,
        scroll: "keep",
        width: 600
      });
    },

    /**
     * Login the user
     */
    login() {
      this.$validator.validateAll().then(result => {
        // Form validation failed
        if (!result) {
          return;
        }

        const loginInput = { username: this.username, password: this.password };
        this.loading = true;

        this.$apollo
          .mutate({
            mutation: authMutations.loginMutation,
            variables: {
              data: loginInput
            }
          })
          .then(({ data }) => {
            data = data.login;
            onLogin(this.$apollo.provider.defaultClient, data.access_token);
            this.commitUserData(data);

            const url = getUrlFromUserRoles(data.roles);
            this.$router.push(url);
          })
          .catch(err => {
            this.$toast.open({
              duration: 5000,
              message: err.message,
              type: "is-danger"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    /**
     * Commit various pieces of data about the user to the Vuex store
     */
    commitUserData(data) {
      this.$store.commit(ROOT_MUTATION_TYPES.SAVE_USER, data.user);
      this.$store.commit(
        ROOT_MUTATION_TYPES.SAVE_ACCESS_TOKEN,
        data.access_token
      );
      this.$store.commit(
        ROOT_MUTATION_TYPES.SAVE_REFRESH_TOKEN,
        data.refresh_token
      );
      this.$store.commit(ROOT_MUTATION_TYPES.SAVE_USER_ROLES, data.roles);
    }
  }
};
</script>


<style scoped>
.card-header-title,
h2 {
  font-family: "Poppins";
  text-align: center;
  justify-content: center;
  color: #3c5081;
  font-size: 1.1em;
  font-weight: bold !important;
  max-width: 300px;
  margin: 0 auto;
}

.card-style {
  padding: 1em;
}
</style>
